import serverRenderingUtils from '../../../helpers/serverRenderingUtils';

/**
 * Fires a new event each time the path is updated
 */
export const firePathUpdateEvent = (pathname?: string) => {
  if (!serverRenderingUtils.windowUndefined()) {
    if (pathname) {
      const event = new CustomEvent('pathnameUpdate', { detail: pathname });
      window.dispatchEvent(event);
    }
  }
};
